import { DuotoneSvgProps } from './types';

export default function NetworkSVG({
  primaryColor,
  secondaryColor,
}: DuotoneSvgProps) {
  return (
    // <!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg
      id="uuid-8215261f-e96d-4a10-9dbd-5463907addab"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <defs>
        <style>
          .nodes&#123;stroke:#fff;stroke-miterlimit:10;stroke-width:4.04px;&#125;
          .edges&#123;fill:none;fill-rule:evenodd;stroke-linejoin:bevel;stroke-width:5.6px;&#125;
        </style>
      </defs>
      <g style={{ stroke: primaryColor }}>
        <polyline
          className="edges"
          points="292.4 392.3 397.4 393.6 421.8 307.1"
        />
        <polyline
          className="edges"
          points="430.4 194.8 312.8 147.4 400.9 72.1 430.4 194.8"
        />
        <polyline className="edges" points="66.3 170.4 183 158.7 141.7 65.3" />
        <polyline
          className="edges"
          points="116.6 432.6 90.5 300.5 191.6 353.7 116.6 432.6"
        />
      </g>
      <g style={{ stroke: secondaryColor }}>
        <polyline
          className="edges"
          points="183 158.7 261.2 254.5 191.6 353.7"
        />
        <polyline
          className="edges"
          points="312.8 147.4 261.2 254.5 430.4 194.8"
        />
      </g>
      <g style={{ fill: primaryColor }}>
        <circle
          id="uuid-c5c4f58c-4ae1-4e69-930c-a6fe8cd5cb62"
          className="nodes"
          cx="66.3"
          cy="169.5"
          r="16.5"
        />
        <circle
          id="uuid-21785f59-91fb-4866-ad0a-b8aaf0dffbe1"
          className="nodes"
          cx="141.7"
          cy="65.3"
          r="16.5"
        />
        <circle
          id="uuid-aa79ac44-90b7-43e3-9063-e89ec5127190"
          className="nodes"
          cx="116.6"
          cy="432.6"
          r="16.5"
        />
        <circle
          id="uuid-5364b129-7945-44ff-9e62-c091258eed44"
          className="nodes"
          cx="402"
          cy="72.1"
          r="16.5"
        />
        <circle
          id="uuid-73ebd4e0-c455-4ee3-92cc-7350ce431000"
          className="nodes"
          cx="430.4"
          cy="193.9"
          r="16.5"
        />
        <circle
          id="uuid-39fd6320-aba4-4fd2-9e40-fd4e34ff04de"
          className="nodes"
          cx="191.6"
          cy="353.7"
          r="16.5"
        />
        <circle
          id="uuid-869f9791-cb96-4cb1-8cc6-dd55ac0c619f"
          className="nodes"
          cx="292.4"
          cy="390.8"
          r="16.5"
        />
        <circle
          id="uuid-6f105e62-decf-4d48-875d-285fd1099436"
          className="nodes"
          cx="397.4"
          cy="393.6"
          r="16.5"
        />
        <circle
          id="uuid-325dab86-8cdd-43db-81b8-b69ac7ebbebd"
          className="nodes"
          cx="421.8"
          cy="307.1"
          r="16.5"
        />
        <circle
          id="uuid-8c7789df-90ea-46ff-bcec-772a0385cd19"
          className="nodes"
          cx="92.3"
          cy="300.5"
          r="16.5"
        />
        <circle
          id="uuid-33c223b9-7ceb-423c-9d50-8e158c4b0c54"
          className="nodes"
          cx="183"
          cy="158.7"
          r="16.5"
        />
        <circle
          id="uuid-449fc218-e479-4e1b-a1fa-0674a9b9ab4e"
          className="nodes"
          cx="312.8"
          cy="147.4"
          r="16.5"
        />
      </g>
      <g style={{ fill: secondaryColor }}>
        <circle
          id="uuid-f8a68f4c-c4bd-4a49-8e2a-453c82f07fab"
          className="nodes"
          cx="261.2"
          cy="254.5"
          r="16.5"
        />
      </g>
    </svg>
    // R = 16.53r
  );
}
